<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：酒店-酒店管理
      -->
  <div class="user clearfix">

    <!--添加酒店-->
    <div class="common-level-rail fl">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" >添加酒店</el-button>
    </div>
    <div class="common-seach-wrap fr">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="酒店 :">
          <el-input v-model="formInline.search" placeholder="请输入酒店名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="城市 :">
          <el-select size="small" v-model="formInline.serviceCityId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in data" :key="index" :label="item.city" :value="item.serviceCityId"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
  
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="酒店ID" width="90"></el-table-column>
          <el-table-column prop="name" label="酒店名称"></el-table-column>
          <el-table-column prop="mobile" label="登录账号"></el-table-column>
          <el-table-column prop="money" label="余额(元)"></el-table-column>
          <el-table-column prop="month_income" label="当前月收入(元)"></el-table-column>
          <el-table-column label="logo" width="80">
            <template slot-scope="scope">
              <el-image v-if="scope.row.qrcode" :src="scope.row.qrcode"
                width="50" height="50"   fit="cover"
                  :preview-src-list="[scope.row.qrcode]"
                  />
            </template>
            
          </el-table-column>
        
          <!-- <el-table-column prop="createTime" label="添加时间" width="150"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <!-- <el-button @click="recycle(scope.row,0)" type="text" size="small"  v-if="scope.row.is_recycle==1" style="color:gray;">开启</el-button>
              <el-button @click="recycle(scope.row,1)" type="text" size="small"  v-else>禁用</el-button> -->
              <el-button @click="editClick(scope.row)" type="primary" size="small" >编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  export default {
    components: {},
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*门店列表数据*/
        storeList: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          shop_id: '',
          search: '',
          serviceCityId:''
        },
        data:[],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        logoImgs: [],
        businessImgs: []
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        Params.name=self.formInline.search
        Params.serviceCityId=self.formInline.serviceCityId
        SupplierApi.hotelList(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.data;
            // self.data=res.data.data
            // self.totalDataNumber = res.data.list.total;
            // self.tableData.forEach(function(item) {
            //   if(item.business){
            //     self.businessImgs.push(item.business.filePath);
            //   }
            //   if(item.logo){
            //     self.logoImgs.push(item.logo.filePath);
            //   }
            // });
          })
          .catch(error => {
            self.loading = false;
          });
      },
      getLogoList(index){
        return this.logoImgs.slice(index).concat(this.logoImgs.slice(0,index))
      },
      getBusinessList(index){
        return this.businessImgs.slice(index).concat(this.businessImgs.slice(0,index))
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*打开添加*/
      addClick() {
        this.$router.push('/supplier/hotelmanagement/add');
      },

      /*打开编辑*/
      editClick(row) {
        let params=row.id
        // console.log(row)
        this.$router.push({
          path: '/supplier/hotelmanagement/edit',
          query: {
            id: params
          }
        })
      },
      /* 强制下架上架*/
      recycle(row,state){
        let self = this;
        let war="";
        if(state==1){
          war="禁止"
        }else if(state==0){
          war="开启"
        }
        self
          .$confirm("确认要"+war+"吗?", '提示', {
            type: 'warning'
          })
          .then(() => {
            SupplierApi.supplierRecycle({
              shopSupplierId: row.shopSupplierId,
              is_recycle:state
            }).then(data => {
              self.$message({
                message: war+'成功',
                type: 'success'
              });
              self.getTableList();
            });
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        console.log(row)
        self.$confirm('确定删除该酒店?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          SupplierApi.hoteldel({
              id: row.id
            }, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，酒店删除成功',
                  type: 'success'
                });
                self.getTableList();
              }
            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {
          self.loading = false;
        });
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/hotelmanagement/index.vue